import wx from 'weixin-js-sdk'
import { getQueryObject } from '@/utils'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { authorize, getWxConfig } from '@/graphql/api.gql'

export const weixinFunc = {
  methods: {
    async weixinAuth(AUTH_TYPE) {
      // 微信授权
      const token = getToken()
      if (!token) {
        const { code } = getQueryObject()
        console.log('拼团页获取 URL 中的 code', code)
        // const url = this.$consts.REDIRECT_URL + `?code=${code}#/group?id=${this.pink.id}`
        code ? await this.authorization(code) : this.redirectToAuthorize(AUTH_TYPE)
      }
    },
    // 重定向到 "确认授权" 页面
    redirectToAuthorize(AUTH_TYPE) {
      const redirectUrl = location.href
      const appId = this.$consts.APP_ID
      const authType = AUTH_TYPE || this.$consts.AUTH_TYPE
      console.log(`跳转静默授权前页面路径 location.href = ${redirectUrl}, appId = ${appId}`)
      console.log('当前scope的值', authType)
      // this.$sentry.captureMessage({ action: '页面跳转', location: location.href, appId: appId })
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=${authType}#wechat_redirect`)
      throw new Error('授权中')
    },
    // 请求后台获取 token 和 用户信息
    authorization(code) {
      const self = this
      return self.$apollo.mutate({
        mutation: authorize,
        variables: { code }
      }).then(res => {
        console.log('code2token: code = %s, result = %O', code, res)
        const { apiToken } = res.data.authMutation
        setToken(apiToken)
      }).catch(err => {
        console.log('清空Token', err)
        removeToken()
      })
    },
    getWeChatConfig(isShare) {
      return this.$apollo.query({
        query: getWxConfig,
        variables: { url: window.location.href.split('#')[0], useWx2: isShare },
        fetchPolicy: 'no-cache'
      }).catch(err => {
        console.error('请求getWxConfig报错', err)
        return Promise.reject(err)
      })
    },
    wechatPay() {
      return this.getWeChatConfig(false)
        .then(res => {
          console.log('得到结果wxconfig', res)
          const { noncestr, signature, timestamp } = res.data.signatureUrl
          const params = {
            appId: this.$consts.APP_ID,
            debug: false,
            timestamp,
            nonceStr: noncestr,
            signature,
            jsApiList: [
              'chooseWXPay',
              'hideMenuItems'
            ]
          }
          console.log('wxconfig信息（支付）', params)
          wx.config(params)
          wx.ready(() => {
            console.log('wx.ready')
            wx.hideMenuItems({ menuList: ['menuItem:copyUrl'] })
          })
          // 步骤五：通过 wx.error 接口处理失败验证
          wx.error(err => console.log('wx.error: ', err))
        })
    },
    wechatShare(shareData) {
      this.getWeChatConfig(true)
        .then(res => {
          console.log('得到结果wxconfig', res)
          const { noncestr, signature, timestamp } = res.data.signatureUrl
          const params = {
            appId: this.$consts.SHARE_APP_ID,
            debug: false,
            timestamp,
            nonceStr: noncestr,
            signature,
            jsApiList: [
              'updateTimelineShareData',
              'updateAppMessageShareData',
              'hideMenuItems',
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ]
          }
          console.log('wxconfig信息(分享)', params)
          wx.config(params)
          wx.ready(() => {
            console.log('wx.ready')
            wx.updateTimelineShareData(shareData)
            console.log('updateTimelineShareData ok')
            wx.updateAppMessageShareData(shareData)
            console.log('updateAppMessageShareData ok')
            wx.onMenuShareAppMessage(shareData) // 兼容客户端 6.7.2及 JSSDK 1.4.0 以下版本
            console.log('onMenuShareAppMessage ok')
            wx.onMenuShareTimeline(shareData) // 兼容客户端 6.7.2及 JSSDK 1.4.0 以下版本
            console.log('onMenuShareTimeline ok')
            wx.hideMenuItems({ menuList: ['menuItem:copyUrl'] })
            console.log('hideMenuItems ok')
          })
          // 步骤五：通过 wx.error 接口处理失败验证
          wx.error(err => console.log('wx.error: ', err))
        })
    }
  }
}
